import { render, staticRenderFns } from "./Bloco2Cover.vue?vue&type=template&id=e610cf2c&scoped=true&"
import script from "./Bloco2Cover.vue?vue&type=script&lang=js&"
export * from "./Bloco2Cover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e610cf2c",
  null
  
)

export default component.exports